import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import i18n from '@/i18n'
import { LoginView } from '@/modules/auth'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/login')({
  beforeLoad: ({ context }) => {
    if (context.authStore?.isAuthenticated) {
      throw redirect({
        to: '/',
        replace: true
      })
    }
  },
  validateSearch: z.object({
    redirect: z.string().catch('/')
  }),
  component: LoginView,
  head: () => getMetaWithPageTitle([i18n.t('title.login', { ns: 'auth' })])
})
